import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { apiUrl } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SubdominiosService {
  storage = null;
  accessToken = '';
  headers = {};
  constructor(private http: HttpClient) {
    this.storage = localStorage.getItem('at');

    if (this.storage) {
      const decode = atob(this.storage);
      this.accessToken = JSON.parse(decode);
    }

    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };
  }

  updateToken(data: any): Observable<any> {
    this.storage = localStorage.getItem(data);
    const decode = atob(data);
    this.accessToken = JSON.parse(decode);
    return;
  }

  addDomain(data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'add',
        data: data,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/customer-infra`, body);
  }
  updateDomain(data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'update_subd',
        data: data,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/customer-infra`, body);
  }
  activateDomain(data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'active_subd',
        data: data,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/customer-infra`, body);
  }
}
